import * as jQuery from 'jquery';
window.$ = $;
window.jQuery = jQuery;
jQuery(function ($) {
    var MOBILE_VIEWPORT = 880; // this should match $viewport-narrow in config.scss
    window.eventHandlers = {};
    window.init = function () {
        this.addEventHandlers();
        this.eventHandlers.resize();
    };
    window.addEventHandlers = function () {
        var $window = $(window);
        var $labels = $('.tab-label[data-tabid]');
        if ($labels.length > 0) {
            $labels.click(function () {
                var $this = $(this);
                var tabId = $this.attr('data-tabid');
                var $container = $this.closest('.tabbed_content');
                var $content = null;
                var $mobileContent = null;
                var $contentsContainer = null;
                $('.tab-label', $container).addClass('inactive').removeClass('active');
                $('.tab-content', $container).addClass('inactive').removeClass('active');
                if ($window.width() <= MOBILE_VIEWPORT) {
                    $content = $('.mobile.tab-content[data-tabid=' + tabId + ']');
                    $mobileContent = $('.mobile-content', $this);
                    if ($mobileContent.attr('data-displaying') == 'true') {
                        $mobileContent.slideUp(200);
                        $mobileContent.attr('data-displaying', 'false');
                        $this.attr('data-displaying', 'false');
                    }
                    else {
                        $mobileContent.slideDown(200);
                        $mobileContent.attr('data-displaying', 'true');
                        $this.attr('data-displaying', 'true');
                    }
                }
                else {
                    $content = $('.desktop.tab-content[data-tabid=' + tabId + ']');
                    $contentsContainer = $content.closest('.tabs-content');
                    $contentsContainer.css('height', $content.height() + 'px');
                }
                $this.addClass('active').removeClass('inactive');
                $content.addClass('active').removeClass('inactive');
            });
            if ($window.width() > MOBILE_VIEWPORT) {
                ;
                $labels.get(0).click();
            }
        }
        $('.site-menu .mobile-toggle').click(function () {
            var $container = $('.mobile-menu-container');
            if ($container.attr('data-open') == 'true') {
                $container.css('max-height', '0');
                $container.attr('data-open', '');
                $(this).css('transform', 'scaleY(0.7)');
            }
            else {
                $container.css('max-height', '60vh');
                $container.attr('data-open', 'true');
                $(this).css('transform', 'scaleY(-0.7)');
            }
        });
        $('video, .play, .unmute').click(function () {
            window.toggleNearestVideo(this);
        });
        $('.year-selector-container').click(function () {
            var $selector = $('.year-selector', this);
            if ($selector.css('display') == 'block') {
                // hide it
                $selector.fadeOut(100);
            }
            else {
                // show it
                $selector.fadeIn(200);
            }
        });
        $(window).resize(this.eventHandlers.resize);
    };
    window.eventHandlers.resize = function () {
        var $footer = $('.page-footer');
        $('body').css('padding-bottom', $footer.outerHeight());
        $footer.css({ position: 'absolute', left: 0, bottom: 0 });
    };
    window.toggleVideo = function (el) {
        var $video = $(el);
        var $parent = $video.parent();
        var $controls = $('.control', $parent);
        var $overlay = $('.overlay', $parent.parent());
        if ($video.prop('muted') || el.paused) {
            if ($video.prop('muted')) {
                $video.prop('muted', false);
                el.currentTime = 0;
            }
            el.play();
            $controls.fadeOut(200);
            $overlay.addClass('hidden');
        }
        else {
            el.pause();
            $controls.fadeIn(100);
            $overlay.removeClass('hidden');
        }
    };
    window.toggleNearestVideo = function (el) {
        var video = $('video', $(el).parent());
        this.toggleVideo(video.get(0));
    };
    window.init();
});
